import { useDictionary } from 'models/dictionaryContext';
import { EDictionaryTypes } from 'models/dictionary';

export const useApplicationDetails = () => {
  const {
    getCivilianPrefix,
    civilianPrefix,
    getGender,
    gender,
    getPhoneCode,
    phoneCode,
    getMake,
    make,
    getMaritalStatus,
    maritalStatus,
    getIdentificationDocumentType,
    identificationDocumentType,
  } = useDictionary();

  const loadDictionaries = async (types: EDictionaryTypes[]) => {
    if (types.includes(EDictionaryTypes.civilianPrefix)) {
      getCivilianPrefix();
    }
    if (types.includes(EDictionaryTypes.Gender)) {
      getGender();
    }
    if (types.includes(EDictionaryTypes.PhoneCode)) {
      getPhoneCode();
    }
    if (types.includes(EDictionaryTypes.Make)) {
      getMake();
    }
    if (types.includes(EDictionaryTypes.MaritalStatus)) {
      getMaritalStatus();
    }
    if (types.includes(EDictionaryTypes.IdentificationDocumentType)) {
      getIdentificationDocumentType();
    }
  };

  return {
    loadDictionaries,
    civilianPrefix,
    gender,
    phoneCode,
    make,
    maritalStatus,
    identificationDocumentType,
  };
};
